// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_bambu_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_bambu_shade: ModuleSchema = {
  "id": "core_bambu_shade",
  "uniqueId": "B3D_ICPVY",
  "createdAt": "2026-10-02T05:13:28.899Z",
  "updatedAt": "2026-10-28T14:58:31.261Z",
  "label": "Threaded Shade",
  "description": "Template starting structure for creating new 3D parametric modules",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_SHADE"
  ],
  "sliders": [
    {
      "key": "baseDia",
      "label": "Shade Outer Diameter",
      "min": 60,
      "max": 140,
      "default": 90,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "shadeH",
      "label": "Shade Height",
      "min": 60,
      "max": 250,
      "default": 170,
      "step": 5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "shadeWall",
      "label": "Wall Thickness",
      "min": 1,
      "max": 4,
      "default": 2,
      "step": 0.25,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternType",
      "label": "Pattern Type (0=Circle, 1=Pentagon, 2=Diamond)",
      "min": 0,
      "max": 2,
      "default": 0,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternSize",
      "label": "Pattern Hole Size",
      "min": 4,
      "max": 14,
      "default": 8,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternRows",
      "label": "Hole Rows",
      "min": 6,
      "max": 28,
      "default": 16,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shade_body",
      "label": "Lampshade Body",
      "default": "#F3F4F6",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "shade_obj",
      "label": "Bambu Lampshade with Thread Collar",
      "name": "Bambu Lampshade with Thread Collar",
      "color": "#F3F4F6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "shade_body",
          "label": "Lampshade Body",
          "name": "Lampshade Body",
          "groupId": 0,
          "colorKey": "shade_body",
          "defaultColor": "#F3F4F6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Full Lampshade",
      "groupId": -1
    }
  ]
};
